import moment from 'moment';
import React, { Component } from 'react';
import Modal from 'react-modal';
import Loader from 'react-loader';
import SelectField from '../shared/SelectField';
import arrow from '../images/arrow.png';
import TasksFiles from './TasksFiles';
import ResultsFilesForm from './ResultsFilesForm';
import * as _ from 'lodash';
import { formValueSelector, reduxForm } from 'redux-form';
import { connect } from 'react-redux';
import { types, typesOfWork } from '../../actions/currentPerformance';
import { transformCourses_course, transformTerms, transformYears } from '../../utils/const';
import { getCurrentYear, getCurrentTerm } from '../../utils/getItemFromRange';
import { NavLink } from 'react-router-dom';
import { createNotification } from '../notifications/notifications';

const selector = formValueSelector('currentPerformance');

class CurrentPerformance extends Component {
  state = {
    tabIndex: 0,
    isModalVisible: false,
    modalTarget: null,
    type: null,
    row: null,
  };

  componentDidMount() {
    const { fetchYears, location, initialize, userId } = this.props;
    if (location.state) initialize(location.state);
    fetchYears();
    this.changeYearValue();
    // this.changeTermValue()
  }

  componentDidUpdate(prevProps, prevState) {
    if (!_.isEqual(this.props.years, prevProps.years)) {
      this.changeYearValue();
    }

    if (!_.isEqual(this.props.terms, prevProps.terms)) {
      this.changeTermValue();
    }

    if (!_.isEqual(this.props.disciplinesByTerm, prevProps.disciplinesByTerm)) {
      this.changeDisciplineValue();
    }

    if (prevProps.myValues.yearId !== this.props.myValues.yearId) {
      this.fetchCurrentTerms();
    }
    if (prevProps.myValues.termId !== this.props.myValues.termId) {
      this.fetchCurrentDisciplines(this.props.myValues.termId);
    }

    // if (prevProps.myValues.subjectId !== this.props.myValues.subjectId || !_.isEqual(prevProps.modalData, this.props.modalData)) {
    //   this.fetchCurrentPerformance()
    // }
  }

  changeYearValue = () => {
    const { years, location } = this.props;

    if (!years || !years.length) return false;

    if (location.state) return this.updateValues({ yearId: location.state.yearId });

    const currentYear = getCurrentYear(years);

    const yearId = currentYear ? currentYear.xp_key : years[years.length - 1].xp_key;

    this.updateValues({ yearId });
  };

  changeTermValue = () => {
    const { terms } = this.props;

    if (!terms || !terms.length) return false;

    const currentTerm = getCurrentTerm(terms);

    const termId = currentTerm ? currentTerm.trmid : terms[terms.length - 1].trmid;

    this.updateValues({ termId });
  };

  changeDisciplineValue = () => {
    const { disciplinesByTerm } = this.props;
    if (!disciplinesByTerm || !disciplinesByTerm[0]) return false;
    const subjectId = disciplinesByTerm[0].cid;
    this.updateValues({ subjectId });
  };

  updateValues = (values) => {
    const { myValues, initialize } = this.props;
    const newValues = { ...myValues, ...values };
    initialize(newValues);
  };

  fetchCurrentTerms = () => {
    const { myValues, fetchTerms } = this.props;
    const { yearId } = myValues;
    fetchTerms(yearId);
  };

  fetchCurrentDisciplines = () => {
    const { fetchDisciplines, myValues } = this.props;
    const { termId } = myValues;
    fetchDisciplines(termId);
  };

  fetchCurrentPerformance = () => {
    const { fetchCurrentPerformances, myValues } = this.props;
    const { subjectId, termId } = myValues;
    subjectId && termId && fetchCurrentPerformances(subjectId, termId);
  };

  handleToggleModal = (isModalVisible, row = null, type = null, typesOfWork = null) => () => {
    const { fetchFiles, fetchStudentFiles, fetchGroupStudentsFiles, userId } = this.props;

    this.setState({ isModalVisible, row, type, modalTarget: typesOfWork });
    if (row) {
      const { sheid, instance } = row;
      if (typesOfWork == 'hwgroup' || typesOfWork == 'ind')
        fetchFiles(sheid, instance, type, typesOfWork);
      typesOfWork == 'resultInd' && fetchStudentFiles(sheid, instance, userId); // получение файлов для инд результата
      typesOfWork == 'resultGroup' && fetchGroupStudentsFiles(sheid, instance, userId); // получение файлов для групп результата
    }
  };

  renderRow = (row, index) => {
    const { groupFilesExist, groupResultFilesExist, filesExist, resultFilesExist } = row;
    const state = this.props.myValues;
    return (
      <tr key={index}>
        <td className="td-center">{moment(row.lessonfulldate).format('DD.MM.YYYY')}</td>
        <td>
          <span style={row.otitle === 'тема занятия не задана' ? { color: '#4e4e4e' } : null}>
            {row.otitle}
          </span>
        </td>
        <td className="td-center" style={{ wordBreak: 'auto-phrase' }}>
          {row.lessontype || <span style={{ color: '#4e4e4e' }}>не указано</span>}
        </td>
        <td className="td-center">{row.grade || <span style={{ color: '#4e4e4e' }}></span>}</td>
        <td className="td-center">
          <p>{row.homeworktext}</p>
          <span>
            <a
              role="button"
              className="underline small-text"
              onClick={this.handleToggleModal(
                true,
                row,
                types.GROUP_TYPE,
                typesOfWork.HOME_WORK_GROUP
              )}
            >
              <span className={groupFilesExist ? 'bold blackColor' : ''}>Задание</span>&nbsp;
              <img src={arrow} alt="*" width={7} />
            </a>
            <a
              role="button"
              className="underline small-text"
              onClick={this.handleToggleModal(
                true,
                row,
                types.GROUP_TYPE,
                typesOfWork.RESULT_WORK_GROUP
              )}
            >
              <span className={groupResultFilesExist ? 'bold blackColor' : ''}>Результат</span>
              &nbsp;
              <img src={arrow} alt="*" width={7} />
            </a>
          </span>
        </td>
        <td className="td-center">
          <p>{row.individualhomeworktext}</p>
          <span>
            <a
              role="button"
              className="underline small-text"
              onClick={this.handleToggleModal(
                true,
                row,
                types.INDIVIDUAL_TYPE,
                typesOfWork.HOME_WORK_IND
              )}
            >
              <span className={filesExist && 'bold'}>Задание</span>&nbsp;
              <img src={arrow} alt="*" width={7} />
            </a>
            <a
              role="button"
              className="underline small-text"
              onClick={this.handleToggleModal(
                true,
                row,
                types.INDIVIDUAL_TYPE,
                typesOfWork.RESULT_WORK_IND
              )}
            >
              <span className={resultFilesExist && 'bold'}>Результат</span>&nbsp;
              <img src={arrow} alt="*" width={7} />
            </a>
          </span>
        </td>

        <td
          title={row.group_question_answers ? 'Тест уже пройден' : ''}
          className="testing_link_cell"
        >
          {!!row.group_questionset && (
            row.group_question_answers ? (
              <a
                href="#"
                onClick={(e) => {
                  e.preventDefault();
                  createNotification('info', 'Тест уже пройден');
                }}
              >
                {row.group_questionset_name}
              </a>
            ) : (
              <NavLink to={{ pathname: `/tests/${row.group_questionset}`, state }}>
                {row.group_questionset_name}
              </NavLink>
            )
          )}
        </td>

        <td
          title={row.student_question_answers ? 'Тест уже пройден' : ''}
          className="testing_link_cell"
        >
          {!!row.student_questionset && (
            row.student_question_answers ? (
              <a
                href="#"
                onClick={(e) => {
                  e.preventDefault();
                  createNotification('info', 'Тест уже пройден');
                }}
              >
                {row.student_questionset_name}
              </a>
            ) : (
              <NavLink to={{ pathname: `/tests/${row.student_questionset}`, state }}>
                {row.student_questionset_name}
              </NavLink>
            )
          )}
        </td>
      </tr>
    );
  };
  render() {
    const {
      years,
      terms,
      disciplines,
      disciplinesByTerm,
      modalData,
      resultIndStudent,
      resultGroupStudents,
      currentPerformances,
      uploadFile,
      deleteFile,
      download,
      isLoading,
      userId,
    } = this.props;

    const { isModalVisible, modalTarget, row, type } = this.state;

    return (
      <div className="uspex 23.jpg jpg23">
        <Modal
          isOpen={isModalVisible}
          onRequestClose={this.handleToggleModal(false)}
          contentLabel="Modal"
        >
          {modalTarget === typesOfWork.HOME_WORK_GROUP && (
            <TasksFiles
              modalData={modalData}
              // resultGroupStudents={resultGroupStudents}
              row={row}
              type={type}
              download={download}
              handleCloseModal={this.handleToggleModal(false)}
            />
          )}
          {modalTarget === typesOfWork.RESULT_WORK_GROUP && (
            <ResultsFilesForm
              modalData={modalData}
              resultGroupStudents={resultGroupStudents}
              row={row}
              type={type}
              modalTarget={modalTarget}
              uploadFile={uploadFile}
              userId={userId}
              deleteFile={deleteFile}
              download={download}
              handleCloseModal={this.handleToggleModal(false)}
            />
          )}
          {modalTarget === typesOfWork.HOME_WORK_IND && (
            <TasksFiles
              modalData={modalData}
              // resultGroupStudents={resultGroupStudents}
              row={row}
              type={type}
              download={download}
              handleCloseModal={this.handleToggleModal(false)}
            />
          )}
          {modalTarget === typesOfWork.RESULT_WORK_IND && (
            <ResultsFilesForm
              modalData={modalData}
              resultIndStudent={resultIndStudent}
              row={row}
              type={type}
              modalTarget={modalTarget}
              uploadFile={uploadFile}
              userId={userId}
              deleteFile={deleteFile}
              download={download}
              handleCloseModal={this.handleToggleModal(false)}
            />
          )}
        </Modal>
        <div className="captions">Текущая успеваемость - журнал занятий</div>
        <div className="selectors">
          <div className="usp__inputs curr_pr_field">
            <div className="inputs__name">Учебный год:</div>
            <div className="inputs__input inputs__input_schedule_small">
              <SelectField
                className="schedule__select"
                name="yearId"
                defaultValue={
                  [...transformYears(years)]
                    .reverse()
                    .filter(
                      (el) =>
                        el.name.split('-')[+moment(Date.now()).format('MM') < 9 ? 1 : 0] ==
                        +moment(Date.now()).format('YYYY')
                    )[0]?.value
                }
                options={[...transformYears(years)]}
              />
            </div>
          </div>

          <div className="usp__inputs curr_pr_field term">
            <div className="inputs__name">Учебный период:</div>
            <div className="inputs__input inputs__input_schedule_small">
              <SelectField
                className="schedule__select"
                name="termId"
                options={transformTerms(terms)}
              />
            </div>
          </div>

          <div className="usp__inputs curr_pr_field subject">
            <div className="inputs__name">Дисциплина:</div>
            <div className="inputs__input inputs__input_schedule_small">
              <SelectField
                className="schedule__select"
                name="subjectId"
                options={transformCourses_course(disciplinesByTerm)}
              />
            </div>
          </div>

          <div className="usp__inputs curr_pr_field" style={{ paddingTop: '27px' }}>
            <button className="input__submit" onClick={this.fetchCurrentPerformance}>
              Обновить
            </button>
          </div>
        </div>
        <Loader loaded={!isLoading} color="#7b2b2a">
          {/* <table className='tg-second new__tg'> */}
          <table className="tg-second2 pr_rep_table">
            <thead>
              <tr>
                <th className="table-title" width="7%" rowSpan={2}>
                  Дата
                </th>
                <th className="table-title" width="22%" rowSpan={2}>
                  Тема
                </th>
                <th className="table-title" width="8%" rowSpan={2}>
                  Вид занятия
                </th>
                <th className="table-title" width="3%" rowSpan={2}>
                  Оценка
                </th>
                <th className="table-title" width="17%" rowSpan={2}>
                  Групповое
                  <br />
                  задание
                </th>
                <th className="table-title" width="17%" rowSpan={2}>
                  Индивидуальное
                  <br />
                  задание
                </th>
                <th className="table-title" width="26%" colSpan={2}>
                  Тестирование{' '}
                </th>
              </tr>
              <tr>
                <th className="table-title">Групповое</th>
                <th className="table-title">Индивидуальное</th>
              </tr>
            </thead>
            <tbody>{currentPerformances.map(this.renderRow)}</tbody>
          </table>
        </Loader>
      </div>
    );
  }
}

const CurrentPerformanceForm = reduxForm({
  form: 'currentPerformance',
  enableReinitialize: true,
})(CurrentPerformance);

export default connect((state) => ({
  myValues: selector(state, 'yearId', 'termId', 'subjectId', 'file', 'filename'),
}))(CurrentPerformanceForm);
